import { all, fork } from 'redux-saga/effects'
import applicationSagas from 'redux/application/sagas'
import errorSaga from 'redux/errorSaga'
import userSagas from 'redux/user/sagas'

export default function* root() {
  yield all([fork(errorSaga), fork(userSagas), fork(applicationSagas)])
}
